<template>
    <u-tooltip-elevation-rounded v-bind="$attrs">
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
    </u-tooltip-elevation-rounded>
</template>

<script>
import UTooltipElevationRounded from "@/components/publish/styles/tooltips/u-tooltip-elevation-rounded.vue";

export default {
    props: {},
    components: {
        UTooltipElevationRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
